export const EDIT_INDEX_WORKER_NAME = "edit_index_worker" as const;

export const EDIT_INDEX_WORKER_DESC = `Updates an existing Index Worker.

Use this tool to edit Index Worker settings such as name, note, sample size, and schedule.

Important behavior:
- When the user asks to pause/stop scheduled execution, set schedule.type to 'not-set'.
- 'not-set' removes the schedule via removeScheduleFromIndexWorker.
- For schedule updates, use one of: daily, weekly, custom.
- Keep pre-questions minimal: identify the target Index Worker first, then ask only for fields to change.

Targeting:
- Provide organizationId.
- Prefer indexWorkerId when available.
- If indexWorkerId is unknown, provide projectId/projectName plus indexWorkerName.
- When references are ambiguous or missing, the tool returns structured input guidance candidates.

Notes:
- This is a write operation and requires explicit confirmation in the chat UI.
- The tool returns project/index-worker navigation paths and URLs for follow-up.`;
